import { parseAriSafely } from '../../../../common/utils';

import { useValidateJiraAlignProjectAri } from './useValidateJiraAlignProjectAri';
import { useValidateJiraIssueAri } from './useValidateJiraIssueAri';
import { useValidateTownsquareProjectAri } from './useValidateTownsquareProjectAri';

export type ValidateImpactedWorkAriResult =
	| { status: 'loading' }
	| { status: 'inWorkspace' }
	| { status: 'notFound' }
	| { status: 'error' }; // transient — callers may collapse this to 'notFound'

/**
 * Orchestrates ARI scope validation for impacted-work resources.
 * Supported resource types and their validators:
 *   - jira/issue         → useValidateJiraIssueAri
 *   - townsquare/project → useValidateTownsquareProjectAri
 *   - jira-align/project → useValidateJiraAlignProjectAri
 */
export const useValidateImpactedWorkAri = (
	ari: string | null,
	currentCloudId: string,
	link: string | null,
): ValidateImpactedWorkAriResult => {
	const jiraResult = useValidateJiraIssueAri(ari, currentCloudId);
	const townsquareResult = useValidateTownsquareProjectAri(ari);
	const jiraAlignResult = useValidateJiraAlignProjectAri(ari, currentCloudId, link);

	const parsed = ari ? parseAriSafely(ari) : null;

	if (parsed?.resourceOwner === 'jira' && parsed?.resourceType === 'issue') return jiraResult;
	if (parsed?.resourceOwner === 'townsquare' && parsed?.resourceType === 'project')
		return townsquareResult;
	if (parsed?.resourceOwner === 'jira-align' && parsed?.resourceType === 'project')
		return jiraAlignResult;

	return { status: 'notFound' };
};
